import CheckIcon from './icons/check-fill-black.svg';
import logo from "./icons/chainvalley-logo.svg";

export const SuccessScreen = () => {
  return (
    <>
      <div className="container">
        <div className="logo logo-wide">
          <img src={logo} alt="Chain Valley" />
        </div>

        <div className="section">
          <div className="success">
            <div className="success-icon">
              <img src={CheckIcon} width={36} height={36} alt="Success" />
            </div>
            <div className="success-message">
              <h2>Card provider migration<br/>to Wirex is successful</h2>
              <p>
                Your card will be ready in the next 5 minutes. If you have any questions, feel free to reach out to our support team in the app.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        Chain Valley Sp. z o.o. &copy; All Rights Reserved.
      </div>
    </>
  );
}
